// extracted by mini-css-extract-plugin
module.exports = {"postTags":"PostTags-module--postTags--28DV8","postTags__link":"PostTags-module--postTags__link--3E0E7"};